import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Col, Select, Typography } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';
import { useCurrencies } from 'v2/hooks/useCurrencies';
import { usePhysicalDeliveryStore } from 'v2/store/PhysicalDelivery';
import { run } from 'validations/ruleRunner';

import Validations from './validations';

interface IProps {
  enabledValidation: boolean;
  onEdit?: () => void;
}

const FixedValue: React.FC<IProps> = ({ enabledValidation, onEdit }) => {
  const { delivery, setDelivery } = usePhysicalDeliveryStore();
  const [validationErrors, setValidationErrors] = useState<any>([]);
  const prevDeliveryRef = useRef(delivery);
  const prevEnabledValidationRef = useRef(enabledValidation);
  const { data: currencies } = useCurrencies();

  const errorFor = (field: any) => validationErrors[field] || '';
  const isValid = (field: any) => !!validationErrors[field];
  const executeValidation = useCallback(() => {
    setValidationErrors(run(delivery, Validations));
  }, [delivery]);
  const handleChange = useCallback(
    (prop: string, value: any) => {
      if (onEdit) onEdit();
      setDelivery({ ...delivery, [prop]: value });
    },
    [delivery, onEdit, setDelivery]
  );

  useEffect(() => {
    if (enabledValidation) executeValidation(); /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  useEffect(() => {
    if (
      (!prevEnabledValidationRef.current && enabledValidation) ||
      (enabledValidation && prevDeliveryRef.current !== delivery)
    )
      executeValidation();
    prevDeliveryRef.current = delivery;
    prevEnabledValidationRef.current = enabledValidation;
  }, [delivery, enabledValidation, executeValidation]);

  return (
    <>
      <Col span={24}>
        <Typography.Text className='mb-1 block text-base'>Moeda</Typography.Text>
        <Select
          id='currency_id'
          className='w-full'
          value={delivery?.currency_id || 1}
          onChange={(value: any) => handleChange('currency_id', value)}
          disabled
          options={
            currencies?.length
              ? currencies.map((curr: any) => ({
                  label: `${curr.code} - ${curr.name}`,
                  value: curr.id,
                  disabled: curr.code !== 'BRL'
                }))
              : []
          }
        />
        <Typography.Text className='text-content-subtitle text-base'>Mesma moeda cadastrada no preço</Typography.Text>
      </Col>
      <Col span={24}>
        <CustomMaskedInput
          label='Valor do frete'
          fullWidth={true}
          disableUnderline
          id='delivery_value'
          mask='money'
          helperText={isValid('delivery_value') ? errorFor('delivery_value') : 'Ex: 10,00'}
          error={isValid('delivery_value')}
          value={delivery.delivery_value}
          onChange={(value: any) => handleChange('delivery_value', value)}
          InputLabelProps={{ shrink: true }}
        />
      </Col>
      <Col span={24}>
        <CustomMaskedInput
          label='Prazo de entrega'
          fullWidth={true}
          disableUnderline
          id='delivery_days'
          mask='number'
          helperText={isValid('delivery_days') ? errorFor('delivery_days') : 'Dias corridos'}
          error={isValid('delivery_days')}
          value={delivery.delivery_days}
          onChange={(value: any) => handleChange('delivery_days', value)}
          InputLabelProps={{ shrink: true }}
          endAdornment='Dias'
        />
      </Col>
    </>
  );
};

export default FixedValue;
